import html2canvas from "html2canvas";

//import item drop images
import auto from '../img/modal-media/wish14loot/auto.jpg';
import handcannon from '../img/modal-media/wish14loot/handcannon.jpg';
import hunterArms from '../img/modal-media/wish14loot/hunter_arms.jpg';
import hunterBoots from '../img/modal-media/wish14loot/hunter_boots.jpg';
import hunterChest from '../img/modal-media/wish14loot/hunter_chest.jpg';
import hunterClass from '../img/modal-media/wish14loot/hunter_class.jpg';
import hunterHelmet from '../img/modal-media/wish14loot/hunter_helmet.jpg';
import rocket from '../img/modal-media/wish14loot/rocket.jpg';
import scout from '../img/modal-media/wish14loot/scout.jpg';
import shotgun from '../img/modal-media/wish14loot/shotgun.jpg';
import sniper from '../img/modal-media/wish14loot/sniper.jpg';
import sword from '../img/modal-media/wish14loot/sword.jpg';
import titanArms from '../img/modal-media/wish14loot/titan_arms.jpg';
import titanBoots from '../img/modal-media/wish14loot/titan_boots.jpg';
import titanChest from '../img/modal-media/wish14loot/titan_chest.jpg';
import titanClass from '../img/modal-media/wish14loot/titan_class.jpg';
import titanHelmet from '../img/modal-media/wish14loot/titan_helmet.jpg';
import WarlockArms from '../img/modal-media/wish14loot/warlock_arms.jpg';
import WarlockBoots from '../img/modal-media/wish14loot/warlock_boots.jpg';
import WarlockChest from '../img/modal-media/wish14loot/warlock_chest.jpg';
import WarlockClass from '../img/modal-media/wish14loot/warlock_class.jpg';
import WarlockHelmet from '../img/modal-media/wish14loot/warlock_helmet.jpg';



 /*///////////////////////////////////////////////////////////////////////
                                        Wish 01 - Etherial Key
///////////////////////////////////////////////////////////////////////*/

function Wish1Effect() {
    /* display modal */
    const modal = document.getElementById("wish1-modal");
    
    modal.style.display= "block";
    const itemSFX = document.querySelector(".itemSfx");
    itemSFX.play();

    /* hide animation after play */
    const item = document.querySelector(".item");
   
       /* get loot drop */
       const loot = document.getElementById("drop");
       /* loot.id ="drop"; */
       loot.id = "afterDrop";

       loot.addEventListener("animationend", ()=>{
        /* loot.id = "afterDrop"; */
        loot.id ="drop";
       });


    /* close modal & pause audio */
    const close1 = document.querySelector(".close1");
    close1.addEventListener("click", function(e) {
        e.preventDefault();
        modal.style.display = "none";
        item.style.display = "block";
    });
}

 /*///////////////////////////////////////////////////////////////////////
                                        Wish 02 - Ship Chest 
///////////////////////////////////////////////////////////////////////*/


function Wish2Effect() {
    /* display modal */
    const modal = document.getElementById("wish2-modal");
    
    modal.style.display= "block";

     /* open chest on click, play sfx, get ship drop  */
    let chest = document.querySelector(".chest"); 

     chest.addEventListener("click", ()=>{

        chest.classList.add("chestOpen");
        const chestSfx = document.querySelector(".chestSfx");
        chestSfx.play();
       
        /* delay ship drop, get loot drop && play sfx */            
            setTimeout(function(){
            const ship = document.querySelector(".shipWrapper");
            
            const sfx = document.querySelector(".shipSfx");
            
            ship.classList.remove("dropShip");
            ship.classList.add("getShip");
            sfx.play();

            ship.addEventListener("animationend", () =>{
            ship.classList.remove("getShip");
            ship.classList.add("dropShip");
            });
               
            },1500);
   
        });
     
     

    /* close modal & pause audio */
    const close2 = document.querySelector(".close2");
    close2.addEventListener("click", function(e) {
        e.preventDefault();
        chest.classList.remove("chestOpen");
        modal.style.display= "none";
    });
}

 /*///////////////////////////////////////////////////////////////////////
                                        Wish 03 - Number of Power Emblem
///////////////////////////////////////////////////////////////////////*/
function Wish3Effect() {
    /* display modal */
    /* const modal = document.getElementById("wish3-modal");
    
    modal.style.display= "block"; */

    /* close modal & pause audio */
    /* const close3 = document.querySelector(".close3");
    close3.addEventListener("click", function(e) {
        e.preventDefault();
        modal.style.display= "none";
    }); */

    /* change header image to Number of Power Embelm */
   document.getElementById("headerRiven").id="headerPower";
}

 /*///////////////////////////////////////////////////////////////////////
                                        Wish 04 - Shuro chi
///////////////////////////////////////////////////////////////////////*/

function Wish4Effect() {
    /* display modal */
    const modal = document.getElementById("wish4-modal");
    
    modal.style.display= "block";

    /* play video */
    let shuroVid = document.querySelector(".shuroChi");

    shuroVid.addEventListener("click", ()=>{
        shuroVid.play();
    });


    /* close modal*/
    const close4 = document.querySelector(".close4");
    close4.addEventListener("click", function(e) {
        e.preventDefault();
        shuroVid.pause();
        shuroVid.currentTime=0;
        modal.style.display= "none";
    });
}

 /*///////////////////////////////////////////////////////////////////////
                                        Wish 05 - Morgeth
///////////////////////////////////////////////////////////////////////*/


function Wish5Effect() {
    /* display modal */
    const modal = document.getElementById("wish5-modal");
    
    modal.style.display= "block";

    /* play video */
    let morgethVid = document.querySelector(".morgeth");

    morgethVid.addEventListener("click", ()=>{
        morgethVid.play();
    });

    /* close modal & pause audio */
    const close5 = document.querySelector(".close5");
    close5.addEventListener("click", function(e) {
        e.preventDefault();
        morgethVid.pause();
        morgethVid.currentTime=0;
        modal.style.display= "none";
    });
}

 /*///////////////////////////////////////////////////////////////////////
                                        Wish 06 - Vault
///////////////////////////////////////////////////////////////////////*/


function Wish6Effect() {
    /* display modal */
    const modal = document.getElementById("wish6-modal");
    
    modal.style.display= "block";

    /* play video */
    let vaultVid = document.querySelector(".vault");

    vaultVid.addEventListener("click", ()=>{
        vaultVid.play();
    });

    /* close modal & pause audio */
    const close6 = document.querySelector(".close6");
    close6.addEventListener("click", function(e) {
        e.preventDefault();
        vaultVid.pause();
        vaultVid.currentTime=0;
        modal.style.display= "none";
    });
}

 /*///////////////////////////////////////////////////////////////////////
                                        Wish 07 - Riven
///////////////////////////////////////////////////////////////////////*/


function Wish7Effect() {
    /* display modal */
    const modal = document.getElementById("wish7-modal");
    
    modal.style.display= "block";

     /* play video */
     let rivenVid = document.querySelector(".riven");

     rivenVid.addEventListener("click", ()=>{
         rivenVid.play();
     });

    /* close modal & pause audio */
    const close7 = document.querySelector(".close7");
    close7.addEventListener("click", function(e) {
        e.preventDefault();
        rivenVid.pause();
        rivenVid.currentTime=0;
        modal.style.display= "none";
    });
}

 /*///////////////////////////////////////////////////////////////////////
                                        Wish 08 - Hope for the Future
///////////////////////////////////////////////////////////////////////*/


function Wish8Effect() {
    /* display modal */
    const modal = document.getElementById("wish8-modal");
    
    modal.style.display= "block";

    /* audio handler */       
    let play = document.querySelector(".playHope");
    let hopeAudio = document.getElementById("audioHope");
    let isPlaying = false;
    
    play.addEventListener("click", (e)=>{
        e.preventDefault();
        isPlaying ? hopeAudio.pause() : hopeAudio.play();        
    });
    
    hopeAudio.onload = function(){
        isPlaying = false;
        hopeAudio.currentTime = 0;
    };
    
    hopeAudio.onpause = function () {
        isPlaying = false;
    };

      hopeAudio.onplaying = function() {
          isPlaying = true;
          hopeAudio.play();
      };

    /* close modal & pause audio */
    const close8 = document.querySelector(".close8");
    close8.addEventListener("click", function(e) {
        e.preventDefault();
        hopeAudio.currentTime = 0;      
        hopeAudio.pause();
        modal.style.display= "none";
    });
}


 /*///////////////////////////////////////////////////////////////////////
                                        Wish 09 - plays Failsafe
///////////////////////////////////////////////////////////////////////*/


function Wish9Effect(){
    /* display modal */
    const modal = document.getElementById("wish9-modal");
    
    modal.style.display= "block";

    /* handle audio */    
    let play = document.querySelector(".play");
    let failSafeAudio = document.getElementById("audioFailsafe");
    let isPlaying = false;
    
    play.addEventListener("click", (e)=>{
        e.preventDefault();
        isPlaying ? failSafeAudio.pause() : failSafeAudio.play();        
    });
    
    failSafeAudio.onload = function(){
        isPlaying = false;
        failSafeAudio.currentTime = 0;
    };
    
    failSafeAudio.onpause = function () {
        isPlaying = false;
    };

      failSafeAudio.onplaying = function() {
          isPlaying = true;
          failSafeAudio.play();
      };
    
  

    /* close modal & pause audio */
    const close9 = document.querySelector(".close9");
    close9.addEventListener("click", function(e) {
        e.preventDefault();
        failSafeAudio.currentTime = 0;      
        failSafeAudio.pause();
        modal.style.display= "none";
    });

}

 /*///////////////////////////////////////////////////////////////////////
                                        Wish 10 - plays Drifter
///////////////////////////////////////////////////////////////////////*/


function Wish10Effect() {
    /* display modal */
    const modal = document.getElementById("wish10-modal");
    
    modal.style.display= "block";

    /* handle audio */    
    let play = document.querySelector(".playDrifter");
    let drifterAudio = document.getElementById("audioDrifter");
    let isPlaying = false;
    
    play.addEventListener("click", (e)=>{
        e.preventDefault();
        isPlaying ? drifterAudio.pause() : drifterAudio.play();        
    });
    
    drifterAudio.onload = function(){
        isPlaying = false;
        drifterAudio.currentTime = 0;
    };
    
    drifterAudio.onpause = function () {
        isPlaying = false;
    };

      drifterAudio.onplaying = function() {
          isPlaying = true;
          drifterAudio.play();
      };

    /* close modal & pause audio */
    const close10 = document.querySelector(".close10");
    close10.addEventListener("click", function(e) {
        e.preventDefault();
        modal.style.display= "none";
        drifterAudio.pause();
        drifterAudio.currentTime = 0;

    });
}

 /*///////////////////////////////////////////////////////////////////////
                                        Wish 11 - Birthday Party Effect
///////////////////////////////////////////////////////////////////////*/


function Wish11Effect() {
    /* display modal */
    const modal = document.getElementById("wish11-modal");
    
    modal.style.display= "block";

    /* Confetti effect */
    var btn = document.querySelector(".wish11Btn");
    var ctx;

html2canvas(btn).then(canvas => {
  ctx = canvas.getContext("2d");
  
  createParticleCanvas();
  
  let reductionFactor = 17;
  btn.addEventListener("click", e => {
    // Get the color data for our button
    let width = btn.offsetWidth;
    let height = btn.offsetHeight
    let colorData = ctx.getImageData(0, 0, width, height).data;

    // Keep track of how many times we've iterated (in order to reduce
    // the total number of particles create)
    let count = 0;

    // Go through every location of our button and create a particle
    for(let localX = 0; localX < width; localX++) {
      for(let localY = 0; localY < height; localY++) {
        if(count % reductionFactor === 0) {
          let index = (localY * width + localX) * 4;
          let rgbaColorArr = colorData.slice(index, index + 4);

          let bcr = btn.getBoundingClientRect();
          let globalX = bcr.left + localX;
          let globalY = bcr.top + localY;

          createParticleAtPoint(globalX, globalY, rgbaColorArr);
        }
        count++;
      }
    }
  });
});

/* play audio (party horn) on click */


/* An "exploding" particle effect that uses circles */
var ExplodingParticle = function() {
  // Set how long we want our particle to animate for
  this.animationDuration = 1000; // in ms

  // Set the speed for our particle
  this.speed = {
    x: -5 + Math.random() * 10,
    y: -5 + Math.random() * 10
  };
  
  // Size our particle
  this.radius = 5 + Math.random() * 5;
  
  // Set a max time to live for our particle
  this.life = 30 + Math.random() * 10;
  this.remainingLife = this.life;
  
  // This function will be called by our animation logic later on
  this.draw = ctx => {
    let p = this;

    if(this.remainingLife > 0
    && this.radius > 0) {
      // Draw a circle at the current location
      ctx.beginPath();
      ctx.arc(p.startX, p.startY, p.radius, 0, Math.PI * 2);
      ctx.fillStyle = "rgba(" + this.rgbArray[0] + ',' + this.rgbArray[1] + ',' + this.rgbArray[2] + ", 1)";
      ctx.fill();
      
      // Update the particle's location and life
      p.remainingLife--;
      p.radius -= 0.25;
      p.startX += p.speed.x;
      p.startY += p.speed.y;
    }
  }
}

var particles = [];
function createParticleAtPoint(x, y, colorData) {
  let particle = new ExplodingParticle();
  particle.rgbArray = colorData;
  particle.startX = x;
  particle.startY = y;
  particle.startTime = Date.now();
  
  particles.push(particle);
}


var particleCanvas, particleCtx;
function createParticleCanvas() {
  // Create our canvas
  particleCanvas = document.createElement("canvas");
  particleCtx = particleCanvas.getContext("2d");
  
  // Size our canvas
  particleCanvas.width = window.innerWidth;
  particleCanvas.height = window.innerHeight;
  
  // Position out canvas
  particleCanvas.style.position = "absolute";
  particleCanvas.style.top = "0";
  particleCanvas.style.left = "0";
  
  // Make sure it's on top of other elements
  particleCanvas.style.zIndex = "1001";
  
  // Make sure other elements under it are clickable
  particleCanvas.style.pointerEvents = "none";
  
  // Add our canvas to the page
  document.body.appendChild(particleCanvas);
}

function update() {
  // Clear out the old particles
  if(typeof particleCtx !== "undefined") {
    particleCtx.clearRect(0, 0, window.innerWidth, window.innerHeight);
  }

  // Draw all of our particles in their new location
  for(let i = 0; i < particles.length; i++) {
    particles[i].draw(particleCtx);
    
    // Simple way to clean up if the last particle is done animating
    if(i === particles.length - 1) {
      let percent = (Date.now() - particles[i].startTime) / particles[i].animationDuration;
      
      if(percent > 1) {
        particles = [];
      }
    }
  }
  
  // Animate performantly
  window.requestAnimationFrame(update);
}
window.requestAnimationFrame(update);


/* follow cursor */
let circle = document.getElementById("circle");

const onMouseMove = (e) =>{
    circle.style.left = e.pageX + "px";
    circle.style.top = e.pageY + "px";    
}

document.addEventListener("mousemove", onMouseMove); 





    /* close modal & pause audio */
    const close11 = document.querySelector(".close11");
    close11.addEventListener("click", function(e) {
        e.preventDefault();
        modal.style.display= "none";
    });
}


 /*///////////////////////////////////////////////////////////////////////
                                        Wish 12 - Fireteam effect
///////////////////////////////////////////////////////////////////////*/


function Wish12Effect() {
    /* display modal */
    const modal = document.getElementById("wish12-modal");
    
    modal.style.display= "block";

    /* //////////////// Partcile 1 - Rainbow Net Effect /////////////////*/
    
     let canvas = document.getElementById("rainbownet"),
     ctx = canvas.getContext("2d"),
     w,
     midX,
     h,
     particles = [];

    const Tau = Math.PI*2,
        ConnectionDist = 50,
        maxParticles = 500,
        radius = 3,
        Msqrt = Math.sqrt,
        Mrandom = Math.random;

    function handleResize(){
        w = ctx.canvas.width = window.innerWidth;
        h = ctx.canvas.height = window.innerHeight;
        midX = w * .5;
    }
    window.onresize = () => handleResize();
    handleResize();

    function createParticles(){
        let vRange = 1.5,
            vMin = .5,
            vx, vy;
        for(let i=0; i < maxParticles; i++){
            vx = Mrandom() * vRange + vMin;
            vy = Mrandom() * vRange + vMin;
            if(Mrandom() > .5){ vx *= -1;}
            if(Mrandom() > .5){ vy *= -1;}
            particles.push({
                x: Mrandom() * w - radius,
                y: Mrandom() * h - radius,
                xv: Mrandom() * vx,
                yv: Mrandom() * vy,
                strokeColor:{h:0, s:1}
            });
        }
    }

    function update(){
        particles.forEach(p =>{
            //move particles
            p.x += p.xv;
            p.y += p.yv;

            //keep in bounds
            if(p.x < 0){
                p.x = 0;
                p.xv *= -1;
            }
            else if(p.x > w){
                p.x = w;
                p.xv *= -1;
            }
            if(p.y < 0){
                p.y = 0;
                p.yv *= -1;
            }
            else if(p.y > h){
                p.y = h;
                p.yv *= -1;
            }            
        });
    }

    function connect(){
        let p1, p2;
        for (let i = 0; i < maxParticles-1; i++) {
            p1 = particles[i];
            for (let j = i + 1; j < maxParticles; j++) {
                p2 = particles[j];
                let currentDist = getDistance(p2.x, p1.x, p2.y, p1.y);
                if (currentDist < ConnectionDist) {
                    ctx.beginPath();
                    ctx.moveTo(p1.x, p1.y);
                    // ctx.strokeStyle = 'hsla(' + p1.hue + ', 50%, 50%, ' + (1 - currentDist * 0.01) + ')';
                    ctx.strokeStyle = 'hsla(' + p1.hue + ', 80%, 80%, ' + (1 - currentDist * 100 / ConnectionDist * 0.01) + ')';
                    ctx.lineTo(p2.x, p2.y, p1.x, p1.y);
                    ctx.stroke();
                }
            }
        }
    }

    function draw() {
        let d;
        particles.forEach(p => {
            d = getDistance(midX, p.x, h, p.y);
            p.hue = d;
            ctx.beginPath();
            ctx.fillStyle = 'hsla(' + d + ' , 50%, 100%, 1)';
            ctx.arc(p.x, p.y, radius, 0, Tau);
            ctx.fill();
        })
    }

    function getDistance(x1, x2, y1, y2) {
        let a = x1 - x2,
            b = y1 - y2;
        return Msqrt(a * a + b * b);
    }

    function animate() {
        canvas.width = w;
        update();
        // Draw connect lines first, so dots are on top
        connect();
        draw();
        requestAnimationFrame(animate);
    }
    
    createParticles();
    animate(); 
    
    

    /* //////////////// Partcile 2 - Rain Effect /////////////////*/
    
const FIXED_STEP = 16;

// Wind
const WIND_VELOCITY = -0.1; // Determines how slanted the rain drops fall, 0 = straight down

// Drop settings
const DROP_COUNT = 200; // Adjust for more/less rain drops
const DROP_WIDTH = 1; // Increase for thicker rain
const DROP_X_BUFFER = 50; // How far to the sides of the screen drops will spawn
const DROP_COLOR = "lightblue";
const DROP_MIN_VELOCITY = 0.3;
const DROP_MAX_VELOCITY = 0.6;
const DROP_MIN_LENGTH = 20;
const DROP_MAX_LENGTH = 40;
const DROP_MIN_ALPHA = 0.3;
const DROP_MAX_ALPHA = 1;

// Math helpers
var math = {
	// Random integer between min and max
	 randomInteger: function (min, max) {
		return Math.round((Math.random() * (max - min)) + min);
	},
	// Linear Interpolation
	lerp: function (a, b, n) {
		return a + ((b - a) * n);
	},
	scaleVector: function (v, s) {
		v.x *= s;
		v.y *= s;
	},
	normalizeVector: function (v) {
		var m = Math.sqrt(v.x * v.x + v.y * v.y);
		math.scaleVector(v, 1 / m);
	}
};

// Initialize our canvas

var stage = document.createElement("canvas");
stage.classList.add("rainCanvas")
stage.width = window.innerWidth;
stage.height = window.innerHeight;
document.querySelector(".rain").append(stage);
var context = stage.getContext("2d");

var lastTime = 0;
 
// Collection of rain drops

var drops = [];

var initDrops = function () {
	for (var i = 0; i < DROP_COUNT; i++) {
		var drop = {};
		resetDrop(drop);
		drop.y = math.randomInteger(0, stage.height);
		drops.push(drop);
	}
};

// Reset a drop to the top of the canvas

var resetDrop = function (drop) {
	var scale = Math.random();
	drop.x = math.randomInteger(-DROP_X_BUFFER, stage.width + DROP_X_BUFFER);
	drop.vx = WIND_VELOCITY;
	drop.vy = math.lerp(DROP_MIN_VELOCITY, DROP_MAX_VELOCITY, scale);
	drop.l = math.lerp(DROP_MIN_LENGTH, DROP_MAX_LENGTH, scale);
	drop.a = math.lerp(DROP_MIN_ALPHA, DROP_MAX_ALPHA, scale);
	drop.y = math.randomInteger(-drop.l, 0);
};

var updateDrops = function (dt) {
	for (var i = drops.length - 1; i >= 0; --i) {
		var drop = drops[i];
		drop.x += drop.vx * dt;
		drop.y += drop.vy * dt;

		if (
			drop.y > stage.height + drop.l
		) {
			resetDrop(drop);
		}
	}
};

var renderDrops = function (context) {
	context.save();
	context.strokeStyle = DROP_COLOR;
	context.lineWidth = DROP_WIDTH;
	context.compositeOperation = "lighter";

	for (var i = 0; i < drops.length; ++i) {
		var drop = drops[i];

		var x1 = Math.round(drop.x);
		var y1 = Math.round(drop.y);

		var v = { x: drop.vx, y: drop.vy };
		math.normalizeVector(v);
		math.scaleVector(v, -drop.l);

		var x2 = Math.round(x1 + v.x);
		var y2 = Math.round(y1 + v.y);

		context.globalAlpha = drop.a;
		context.beginPath();
		context.moveTo(x1, y1);
		context.lineTo(x2, y2);
		context.stroke();
		context.closePath();
	}
	context.restore();
};

var render = function () {
    context.fillStyle ="black";
	context.fillRect(0, 0, stage.width, stage.height);
	renderDrops(context);
}

var updateRender = function (time) {
	var dt = time - lastTime;
	lastTime = time;
	if (dt > 100) { dt = FIXED_STEP; }

	while (dt >= FIXED_STEP) {
		updateDrops(FIXED_STEP);
		dt -= FIXED_STEP;
	}

	render();
	requestAnimationFrame(updateRender);
};

initDrops();
requestAnimationFrame(updateRender);
 

    /* //////////////// Partcile 3 - Ghosts/Glow Particle /////////////////*/
    // Some random colors
const colors = ["#dacfa6", "#daa6a6", "#a6b1da", "#a6dac5", "#baa6da"];

const numBalls = 100;
const balls = [];

for (let i = 0; i < numBalls; i++) {
  let ball = document.createElement("div");
  ball.classList.add("ball");
  ball.style.background = colors[Math.floor(Math.random() * colors.length)];
  ball.style.left = `${Math.floor(Math.random() * 100)}vw`;
  ball.style.top = `${Math.floor(Math.random() * 100)}vh`;
  ball.style.transform = `scale(${Math.random()})`;
  ball.style.width = `${Math.random()}em`;
  ball.style.height = ball.style.width;
  
  balls.push(ball);
  document.querySelector(".littleLight").append(ball);
}

// Keyframes
balls.forEach((el, i, ra) => {
  let to = {
    x: Math.random() * (i % 2 === 0 ? -11 : 11),
    y: Math.random() * 12
  };

  // eslint-disable-next-line
  let anim = el.animate(
    [
      { transform: "translate(0, 0)" },
      { transform: `translate(${to.x}rem, ${to.y}rem)` }
    ],
    {
      duration: (Math.random() + 1) * 2000, // random duration
      direction: "alternate",
      fill: "both",
      iterations: Infinity,
      easing: "ease-in-out"
    }
  );
});


/* /// Choose random a div/canvas (Particle Effect) /// */
let rainbowNet = document.querySelector("#rainbownet");
let rain = document.querySelector(".rain");
let littleLight = document.querySelector(".littleLight");

let fxArray = [rainbowNet, rain, littleLight];

let randomEffect = 
fxArray[Math.floor(Math.random() * fxArray.length)];

randomEffect.classList.remove("hide");
randomEffect.classList.add("show");




    /* close modal & pause audio */
    const close12 = document.querySelector(".close12");
    close12.addEventListener("click", function(e) {
        e.preventDefault();

         /* remove rain canvas when it's created */
        let rainParent = document.querySelector(".rain");
        rainParent.querySelectorAll(".rainCanvas").forEach(n => n.remove());

        /* remove all littleLights/Balls */
        let lightsParent = document.querySelector(".littleLight");
        lightsParent.querySelectorAll(".ball").forEach(n => n.remove());

        /* Hide child elements */
        if(rainbowNet.classList.contains("show") || rain.classList.contains("show") || littleLight.classList.contains("show")){
            rainbowNet.classList.remove("show");
            rain.classList.remove("show");
            littleLight.classList.remove("show");

            rainbowNet.classList.add("hide");
            rain.classList.add("hide");
            littleLight.classList.add("hide");
        };

       
        modal.style.display= "none";
    });
}

 /*///////////////////////////////////////////////////////////////////////
                                        Wish 13 - Petra's Run
///////////////////////////////////////////////////////////////////////*/


function Wish13Effect() {
    /* display modal */
    const modal = document.getElementById("wish13-modal");
    
    modal.style.display= "block";

    /* Play Petra's voice line */
    const petra = document.querySelector(".petraAudio");
    petra.play();

    /* close modal & pause & reset audio */
    const close13 = document.querySelector(".close13");
    close13.addEventListener("click", function(e) {
        e.preventDefault();
        modal.style.display= "none";
        petra.pause();
        petra.currentTime = 0;

    });
}

 /*///////////////////////////////////////////////////////////////////////
                                        Wish 14 - Ahamkara Eggs
///////////////////////////////////////////////////////////////////////*/


function Wish14Effect() {
    /* display modal */
    const modal = document.getElementById("wish14-modal");
    
    modal.style.display = "block";

    /* randomize images (eggs) */
    let eggs = document.querySelectorAll(".egg");

    //get window width & height
    const winWidth = window.innerWidth;
    const winHeight = window.innerHeight;

    for (let i = 0; i< eggs.length; i++) {
      //shortcut the current div in the list
      let thisEgg = eggs[i];

        //returns a random number between a min & max
        
        //get random numbers for each element
        let randomTop = getRandomNumber(0, winHeight);
        let randomLeft = getRandomNumber(0, winWidth);
        
        //update top & left position
        thisEgg.style.top = randomTop + "px";
        thisEgg.style.left = randomLeft + "px";

         /* egg onclick Event, let eggs vanish when clicked */
        eggs[i].addEventListener("click", ()=>{

            eggs[i].style.display = "none";

            /* // give loot, display random image from loot table // */

            /* get loot drop && play sfx */
            const itemSfx14 = document.querySelector(".itemSfx14");
            const eggLoot = document.getElementById("eggLoot"); //drop = display none

                document.getElementById('eggLoot').id='eggLootDrop';
                itemSfx14.play();
           

            eggLoot.addEventListener("animationend", ()=>{
                eggLoot.id='eggLoot';
            });
            
            

            /* randomize loot drops */
            const lootDrop = document.querySelector(".loot");
            const lootTable = [auto,handcannon,rocket,scout,shotgun,sniper,sword,
                                hunterHelmet,hunterArms,hunterChest,hunterBoots,hunterClass,
                                titanHelmet,titanArms,titanChest,titanBoots,titanClass,
                                WarlockHelmet,WarlockArms,WarlockChest,WarlockBoots,WarlockClass];
            
            let num = Math.floor(Math.random() * lootTable.length);
            lootDrop.src = lootTable[num];

            
            
        },false);
 
    };
    
    function getRandomNumber(min,max) {
        return Math.random() * (max - min) + min;
    };


    /* close modal & pause audio */
    const close14 = document.querySelector(".close14");
    close14.addEventListener("click", function(e) {
        e.preventDefault();
        modal.style.display= "none";
    });
}

 /*///////////////////////////////////////////////////////////////////////
                                 Wish 15 - The Helmet stayed on ( ͡° ͜ʖ ͡°)
///////////////////////////////////////////////////////////////////////*/
function Wish15Effect() {
    /* display modal */
    const modal = document.getElementById("wish15-modal");
    
    modal.style.display= "block";

    /* text to speech */
    let txt = `I wish to be feared.
    Mara stared at the Wall of Wishes. She had no more bargains to make. Her plans were in motion.    
    There was nothing left but the wait.    
    She pulled a sidearm from a hidden holster and cracked a dozen rounds into the Wall.    
    The cosmic balance shifted. Somewhere in the Dreaming City, Riven heard the Queen's wish and a thousand shrieking tears in reality cut through the space in front of her.
    Lord Shaxx suddenly blocked Mara's view of the Wall.    
    "—YES, AND WE'D ALL BE DEAD!" He was screaming at no one, with a mug of caffeine in his fist.    
    He started, almost spilling his coffee. "Where are we?"    
    Mara slapped the mug out of his hand. It shattered on the floor. She shoved a weathered book in his face. "I told you there would come a time when I collect for the Reef Wars. Read this. Out loud."
    "No one tells me what to do," he said, grabbing the book and incinerating it in a bolt of Striker lightning. "I can recite The Tempest by heart." And he did. Mara sat and listened. They stayed for a long time.
    The helmet stayed on.`;

    let speak = new SpeechSynthesisUtterance(txt);
    speak.lang = 'en-UK';

    speechSynthesis.speak(speak);

    /* close modal & pause audio */
    const close15 = document.querySelector(".close15");
    close15.addEventListener("click", function(e) {
        e.preventDefault();
        window.speechSynthesis.pause();
        window.speechSynthesis.cancel();
        modal.style.display= "none";
    });
}




/* ///////////////EXPORT/////////////// */
export {Wish1Effect,Wish2Effect,Wish3Effect,Wish4Effect,Wish5Effect,Wish6Effect,Wish7Effect,
        Wish8Effect,Wish9Effect,Wish10Effect,Wish11Effect,Wish12Effect,Wish13Effect,Wish14Effect,Wish15Effect};